import { extractScSd, getBasePriceFromIncludedPrice, getParsedNumber, roundNumber } from "../utils/Common";
import { recalculateTotalGroupPrice } from "./order-add-edit-service";

export const subtotalObjDefault = {
  vatApplicableDiscountApplicableSubtotal: 0,
  vatApplicableDiscountNotApplicableSubtotal: 0,
  vatNotApplicableDiscountApplicableSubtotal: 0,
  vatNotApplicableDiscountNotApplicableSubtotal: 0,
};

export const sdObjDefault = {
  vatApplicableDiscountApplicableSd: 0,
  vatApplicableDiscountNotApplicableSd: 0,
  vatNotApplicableDiscountApplicableSd: 0,
  vatNotApplicableDiscountNotApplicableSd: 0,
};

const getScForVatNotApplicable = (totalFoodPrice, scPercent, sdPercent) => {
  const priceObj = extractScSd(totalFoodPrice, scPercent, sdPercent);

  console.log("--------getScForVatNotApplicable--------", { totalFoodPrice, sdPercent, scPercent, priceObj });

  return priceObj.serviceCharge;
};

/**
 * This method is for vat excluded system
 * @param {*} foodItem
 */
const getSubtotalObj = (subtotalObj, foodItem, foodPrice) => {
  if (foodItem.isVatApplicable && foodItem.isDiscountApplicable) {
    subtotalObj.vatApplicableDiscountApplicableSubtotal += foodPrice;
  } else if (foodItem.isVatApplicable && !foodItem.isDiscountApplicable) {
    subtotalObj.vatApplicableDiscountNotApplicableSubtotal += foodPrice;
  } else if (!foodItem.isVatApplicable && foodItem.isDiscountApplicable) {
    subtotalObj.vatNotApplicableDiscountApplicableSubtotal += foodPrice;
  } else {
    subtotalObj.vatNotApplicableDiscountNotApplicableSubtotal += foodPrice;
  }

  return subtotalObj;
};

/**
 * This method is for vat exculded system
 * @param {*} foodItem
 */
const getSdObj = (sdObj, foodItem, foodPrice, isScIncluded, isSdIncluded, scPercent) => {
  console.log("*******getSdObj*******", { sdObj, foodItem });

  if (!foodItem.isSupplementaryDutyApplicable) {
    return sdObj;
  }

  console.log('===============sdObj, foodItem, foodPrice, isScIncluded, isSdIncluded, scPercent==============', {sdObj, foodItem, foodPrice, isScIncluded, isSdIncluded, scPercent});

  let sd = 0;

  if (isSdIncluded && isScIncluded) {
    const priceObj = extractScSd(foodPrice, scPercent, foodItem.supplementaryDuty);
    sd = priceObj.supplementaryDuty;
  } else if (isSdIncluded && !isScIncluded) {
    const withoutSdFoodPrice = getBasePriceFromIncludedPrice(foodPrice, foodItem.supplementaryDuty);
    sd = foodPrice - withoutSdFoodPrice;
  } else if (!isSdIncluded && isScIncluded) {
    const withouScFoodPrice = getBasePriceFromIncludedPrice(foodPrice, scPercent);
    sd = (withouScFoodPrice * foodItem.supplementaryDuty) / 100;
    console.log('--!isSdIncluded && isScIncluded----sd-------', sd);
  } else {
    sd = (foodPrice * foodItem.supplementaryDuty) / 100;
  }

  if (foodItem.isVatApplicable && foodItem.isDiscountApplicable) {
    sdObj.vatApplicableDiscountApplicableSd += sd;
    console.log('--sdObj--', {sd, sdObj});
  } else if (foodItem.isVatApplicable && !foodItem.isDiscountApplicable) {
    sdObj.vatApplicableDiscountNotApplicableSd += sd;
  } else if (!foodItem.isVatApplicable && foodItem.isDiscountApplicable) {
    sdObj.vatNotApplicableDiscountApplicableSd += sd;
  } else {
    sdObj.vatNotApplicableDiscountNotApplicableSd += sd;
  }

  return sdObj;
};

export const getFoodWiseData = (foodItem, isVatIncluded, isSdIncluded, isScIncluded, scPercent) => {
  const quantity = 1;
  let addOnsPrice = foodItem.addOns.reduce((sum, addOn) => sum + addOn.price, 0);
  addOnsPrice = addOnsPrice * quantity;
  const totalAdditionGroupsPrice = recalculateTotalGroupPrice(foodItem.additionGroups, quantity);

  console.log('*****getFoodWiseData********totalAdditionGroupsPrice*********************', {totalAdditionGroupsPrice, foodItem, "foodItem.additionGroups": foodItem.additionGroups});

  let foodPrice = roundNumber(foodItem.option.price * quantity + addOnsPrice);
  foodPrice = roundNumber(foodPrice + totalAdditionGroupsPrice);

  if (isVatIncluded) {
    return {
      foodPrice,
      vatApplicablePrice: 0,
      scApplicablePrice: 0,
      sd: 0,
    };
  }

  let vatApplicablePrice = 0;
  let scApplicablePrice = 0;
  let sd = 0;

  /**
   * Vat Excluded has following SD cases
   *          -> Vat not applicable
   *          -> Vat applicable
   *          -> SD applicable
   *          -> SD not applicable
   * Case 1: SD Included sc included
   *======I> In this Case SD always be zero and vatApplicablePrice will be the food price for vat applicable food (sd applicable or not no need to check) 
   * Case 2: SD Included sc excluded: here sc will applied to only food price not whole food price
   *======I> In this Case return sd will be zero but need to get food price without sd and vatApplicablePrice will be the food price for vat applicable food (SD Applicable or not no need to check as food price consist of SD)
   * Case 3: SD excluded sc excluded
   *========1> SD will have a value if SD Applicable
   *========2> vat applicable price will have two case
   ==============I> only food price when SD not applicable
   ==============I> food price + sd when sd applicable
   * Case 4: SD excluded sc included
   *========1> SD will have a value from only food price if SD Applicable
   *========2> vat applicable price will have two case
   ==============I> only food price when SD not applicable
   ==============I> food price + sd when sd applicable
   */
  // ===> SD included Cases 1 and 2 zero SD will be added to total sd, so SD applicable no need to check
  //isSdIncluded && !foodItem.isVatApplicable not need to handle it as vatApplicablePrice and sd will be zero
  // case 1
  if (isSdIncluded) {
    if (isScIncluded) {
      scApplicablePrice = 0;
      vatApplicablePrice = foodItem.isVatApplicable
        ? foodPrice
        : getScForVatNotApplicable(foodPrice, scPercent, foodItem.supplementaryDuty);
    } else {
      let withoutSdFoodPrice = foodPrice;
      if (foodItem.supplementaryDuty > 0) {
        withoutSdFoodPrice = getBasePriceFromIncludedPrice(foodPrice, foodItem.supplementaryDuty);
      }

      scApplicablePrice = withoutSdFoodPrice;
      vatApplicablePrice = foodItem.isVatApplicable ? foodPrice : 0;
    }

    return {
      foodPrice,
      vatApplicablePrice,
      scApplicablePrice,
      sd: 0,
    };
  }

  // Case 3, 4 SD should be added to total sd if sd applicable
  if (!isSdIncluded) {
    if (isScIncluded) {
      scApplicablePrice = 0;
      const foodPriceWithoutSc = getBasePriceFromIncludedPrice(foodPrice, scPercent);
      sd = (foodPriceWithoutSc * foodItem.supplementaryDuty) / 100;
      vatApplicablePrice = foodItem.isVatApplicable ? foodPrice + sd : foodPrice - foodPriceWithoutSc;

      console.log("==!isSdIncluded===isScIncluded==", {
        vatApplicablePrice,
        foodPrice,
        scPercent,
        supplementaryDuty: foodItem.supplementaryDuty,
        foodId: foodItem.foodId,
      });
    } else {
      scApplicablePrice = foodPrice;
      sd = (foodPrice * foodItem.supplementaryDuty) / 100;
      vatApplicablePrice = foodItem.isVatApplicable ? foodPrice + sd : 0;
    }

    return {
      foodPrice,
      vatApplicablePrice,
      scApplicablePrice,
      sd,
    };
  }

  console.log("************This line should not executed. If executed then there have a problem.*************");
  return {
    foodPrice: 0,
    vatApplicablePrice: 0,
    scApplicablePrice: 0,
    sd: 0,
  };
};

export function calculatePriceSummary(foodItems, isVatIncluded, isSdIncluded, isScIncluded, vatPercent, scPercent) {
  const subtotalObj = {
    vatApplicableDiscountApplicableSubtotal: 0,
    vatApplicableDiscountNotApplicableSubtotal: 0,
    vatNotApplicableDiscountApplicableSubtotal: 0,
    vatNotApplicableDiscountNotApplicableSubtotal: 0,
  };

  const sdObj = {
    vatApplicableDiscountApplicableSd: 0,
    vatApplicableDiscountNotApplicableSd: 0,
    vatNotApplicableDiscountApplicableSd: 0,
    vatNotApplicableDiscountNotApplicableSd: 0,
  };

  if (foodItems.length === 0) {
    return {
      subtotal: 0,
      discountApplicablePrice: 0,
      serviceCharge: 0,
      sd: 0,
      vat: 0,
      foodPriceBeforeDiscount: 0,
      totalPriceBeforeDiscount: 0,
      grossTotal: 0,
      subtotalObj,
      sdObj,
    };
  }

  let totalFoodPrice = 0;
  let totalVatApplicable = 0;
  let totalScApplicable = 0;
  let totalSd = 0;

  foodItems.map((foodItem) => {
    if (!foodItem.isSelected) {
      return;
    }

    const calcValues = getFoodWiseData(foodItem, isVatIncluded, isSdIncluded, isScIncluded, scPercent);
    totalFoodPrice = totalFoodPrice + calcValues.foodPrice;
    totalScApplicable = totalScApplicable + calcValues.scApplicablePrice;
    totalVatApplicable = totalVatApplicable + calcValues.vatApplicablePrice;
    totalSd = totalSd + calcValues.sd;
    getSubtotalObj(subtotalObj, foodItem, calcValues.foodPrice);
    getSdObj(sdObj, foodItem, calcValues.foodPrice, isScIncluded, isSdIncluded, scPercent);
  });

  const discountApplicablePrice =
    subtotalObj.vatApplicableDiscountApplicableSubtotal + subtotalObj.vatNotApplicableDiscountApplicableSubtotal;
  if (isVatIncluded) {
    return {
      subtotal: totalFoodPrice,
      discountApplicablePrice,
      serviceCharge: 0,
      sd: 0,
      vat: 0,
      foodPriceBeforeDiscount: totalFoodPrice,
      totalPriceBeforeDiscount: totalFoodPrice,
      grossTotal: totalFoodPrice,
      subtotalObj,
      sdObj,
    };
  }
  /** Vat excluded, sd or sc can be included or excluded, vat can be applicable, sd can be applicable */
  const calculatedSc = roundNumber((totalScApplicable * scPercent) / 100);
  const netVatApplicable = totalVatApplicable + calculatedSc;
  const calculatedVat = roundNumber((netVatApplicable * vatPercent) / 100);

  return {
    subtotal: totalFoodPrice,
    discountApplicablePrice,
    serviceCharge: calculatedSc,
    sd: totalSd,
    vat: calculatedVat,
    foodPriceBeforeDiscount: totalFoodPrice,
    totalPriceBeforeDiscount: totalFoodPrice,
    grossTotal: roundNumber(totalFoodPrice + totalSd + calculatedSc + calculatedVat),
    subtotalObj,
    sdObj,
  };
}
